import state from './state.ts';

export default {
  namespaced: true,
  state
};
